import { cn } from "@/lib/utils";

interface GoldTextProps {
  text: string | number;
  className?: string;
}

const GoldText = (props: GoldTextProps) => {
  const { text, className } = props;
  return <div className={cn("gold-text", className)}>{text}</div>;
};

export default GoldText;
